import { useEffect, useRef, useState } from "react"
import { createOkxSwapWidget } from "@okxweb3/dex-widget"

function App() {
    const widgetRef = useRef(null);
    const [width, setWidth] = useState(getInitialWidth());

    function getInitialWidth() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        return vw > 510 ? 510 : vw - 32; // 32px padding for mobile
    }

    useEffect(() => {
        function handleResize() {
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            setWidth(vw > 510 ? 510 : vw - 32);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const params = {
        chainIds: [501], // [1, 501] , 1 (Mainnet), 56 (BSC), 501 (Solana)
        theme: "dark", // light/dark or provide your own color palette
        tradeType: "swap", // The type of transaction. It can be "swap", "bridge", or "auto".
        providerType: "SOLANA", // ProviderType represents the type of the provider and corresponds to it one-to-one. For example, if the provider is Solana, then the providerType would be SOLANA.
        lang: "unknown",
        provider: "SOLANA-solanawallet",
        baseUrl: "https://www.okx.com",
        width: width, // Dynamic width
        tokenPair: {
            fromChain: 501,
            toChain: 501,
            fromToken: "11111111111111111111111111111111",
            toToken: "BYZ9CcZGKAXmN2uDsKcQMM9UnZacija4vWcns9Th69xb",
        }
    }

    const provider = window.solana;

    const initialConfig = {
        params,
        provider,
        listeners: [
            {
                event: "ON_CONNECT_WALLET",
                handler: async (token, preToken) => {
                    try {
                        if (window.solana && window.solana.connect) {
                            await window.solana.connect();
                        } else if (window.solana && window.solana.request) {
                            await window.solana.request({ method: 'connect' });
                        } else {
                            console.error('Solana wallet not found');
                        }
                    } catch (error) {
                        console.error('Error connecting to Solana wallet:', error);
                    }
                },
            },
        ],
    };

    useEffect(() => {
        if (!widgetRef.current) return;
        
        const widgetHandler = createOkxSwapWidget(
            widgetRef.current,
            initialConfig
        );

        return () => {
            widgetHandler?.destroy();
        };
    }, [width]); // Recreate widget when width changes

    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000000',
            margin: 0,
            padding: '16px',
            overflow: 'hidden',
            gap: '20px'
        }}>
            <a 
                href="https://botify.cloud"
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: 'pointer' }}
            >
                <img 
                    src="/logooo.png" 
                    alt="Logo" 
                    style={{
                        maxWidth: '200px',
                        height: 'auto',
                        marginBottom: '20px'
                    }}
                />
            </a>
            <div ref={widgetRef} style={{ 
                backgroundColor: '#000000',
                maxWidth: '100%'
            }} />
            <div style={{ marginTop: '20px', color: '#808080', fontSize: '14px' }}>
                Only on <a 
                    href="https://botify.cloud" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                        color: '#808080',
                        textDecoration: 'none',
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    Botify.cloud
                </a>
            </div>
        </div>
    );
}

export default App;
